import { render, staticRenderFns } from "./koejakso-card-content.vue?vue&type=template&id=2c9c0fe2&scoped=true&"
import script from "./koejakso-card-content.vue?vue&type=script&lang=ts&"
export * from "./koejakso-card-content.vue?vue&type=script&lang=ts&"
import style0 from "./koejakso-card-content.vue?vue&type=style&index=0&id=2c9c0fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c0fe2",
  null
  
)

export default component.exports